import {createAnatomy} from '@zag-js/anatomy';

export const sidebarAnatomy = createAnatomy(`nav`).parts(
  `container`,
  `footer`,
  `header`,
  `icon`,
  `menu`,
  `menu-item`,
  `menu-group`,
);

export const parts = sidebarAnatomy.build();

export type Part = keyof typeof parts;
